module.exports = __webpack_public_path__ + "img/cutoffwell.715ec3d1.png";